export default async function closeModal() {
    const message = {
        close: true
    }
    window.parent.postMessage(message, "*");
    return true
}